import React from 'react';
import Routes from './Routes';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ConnectionErrorBanner from './components/ui/ConnectionErrorBanner';

const AppContent = () => {
  const { connectionError } = useAuth();
  
  const handleRetry = () => {
    window.location?.reload();
  };
  
  return (
    <>
      <ConnectionErrorBanner message={connectionError} onRetry={handleRetry} />
      <div className={connectionError ? 'pt-20' : ''}>
        <Routes />
      </div>
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;

import './styles/tailwind.css';
import './styles/index.css';